import { jsBridge } from '@/assets/jsBridge'
import { getKey } from '@/assets/utils'
import { mapActions } from 'vuex'
import qs from 'qs'

export default {
  data () {
    return {
      source: '',
      payStatusInfo: {}
    }
  },
  async mounted () {
    const { token } = this.$route.query || {}
    if (token) {
      const res = await this.memberInfo()
      let { memberGoodsGroupCd } = res.data || {}
      if (res.success) {
        // 如果不是会员 跳前置页
        if (memberGoodsGroupCd === 'SVIP') {
          jsBridge('exit', { purchaseSuccessSVIP: 'success' })
        }
      }
    } else {
      this.jumpMiddle()
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path === '/vip/middle') {
      jsBridge('exit')
    } else {
      next()
    }
  },
  methods: {
    ...mapActions('vip', [
      'memberInfo',
      'orderList'
    ]),
    // 跳转到收银台
    async jumpMiddle () {
      const { discountPrice, memberGoodsGroupCd, memberGoodsCd, modeOfPayment } = this.$route.query || {}
      let discountPriceValue = ''
      let mode = {}
      let goods = ''
      if (modeOfPayment === 'continue') {
        const res = await this.orderList({ Status: '' })
        const { originalAmount, couponUseDetail, reducedAmount, goodsCd } = res.data || {}
        discountPriceValue = originalAmount
        goods = goodsCd
        mode = { couponUseDetail: JSON.stringify(couponUseDetail), modeType: 'continue', reducedAmount }
      }
      this.dialog = false
      let host = encodeURIComponent(window.location.href)
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let device = this.getDevice()
      const origin = process.env.VUE_APP_PAYURL
      const channel = getKey('channel') || ''
      const path = '/pay'
      const query = { 
        host,
        gid,
        token,
        channel,
        device,
        modeType: modeOfPayment,
        discountPrice: discountPriceValue || discountPrice,
        memberType: goods || memberGoodsCd,
        memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
        status: this.status,
        ...mode
      }
      window.location.href = `${origin}${path}?${qs.stringify(query)}&refurl=${window.location.origin}`
      // this.$router.push(
      //   { path: '/vip/middle',
      //     query: {
      //       host,
      //       gid,
      //       token,
      //       device,
      //       modeType: modeOfPayment,
      //       discountPrice: discountPriceValue || discountPrice,
      //       memberType: goods || memberGoodsCd,
      //       memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
      //       status: this.status,
      //       ...mode
      //     } 
      //   }
      // )
    }
  },
  render () {
    return <div/>
  }
}